

































































































































import FormContract from '@/app/shared/components/forms/contract.vue';
import FormPolicy from '@/app/shared/components/forms/policy.vue';
import {
  ContractModel,
  PolicyModel,
  VForm,
  InteractionModel,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
@Component({ components: { FormContract, FormPolicy } })
export default class DialogContractComponent extends Vue {
  @Ref() private formContract!: VForm;
  @Ref() private formPolicy!: VForm;

  private contract: ContractModel = new ContractModel();
  private policy: PolicyModel = new PolicyModel();

  private dialog = false;
  private valueTab = '';
  private loading = true;
  private createCampaignBlockStatus = true;

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get updateContract() {
    return this.contract.DueDateUpdateDate
      ? this.refs
          .moment()
          .diff(this.refs.moment(this.contract.DueDateUpdateDate), 'month') > 6
      : true;
  }

  private async mounted() {
    this.loading = true;
    await this.refs.modules.contract.getCampaignBlock(
      this.refs.modules.contract.contract.Id
    );
    this.createCampaignBlockStatus = this.refs.modules.contract.blockedInCampaing;
    this.loading = false;
  }

  private async saveContract() {
    if (this.formContract && !this.formContract.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.formContract && this.formContract.validate()) {
      await this.refs.modules.contract
        .updateContract({
          contractId: this.contract.Id,
          contract: this.contract,
          update: this.updateContract,
        })
        .then(async () => {
          this.$toast(this.$t('toasts.change_contract_detail_successfully'));
          this.refs.modules.ticket.SET_EDIT_CONTRACT(true);
          await this.refs.modules.contract.loadContractById(
            this.$route.params.id
          );
          this.dialog = false;
        })
        .catch((err) => {
          this.$toast.error('ERROR ? ', err);
          this.$toast.error(this.$t('toasts.change_contract_detail_error'));
        });
    }
  }
  private savePolicy() {
    if (this.formPolicy && !this.formPolicy.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    if (this.formPolicy && this.formPolicy.validate()) {
      this.refs.modules.policy
        .updatePolicy({
          policyId: this.policy.Id,
          policy: this.policy,
        })
        .then(async () => {
          this.$toast(this.$t('toasts.change_contract_detail_successfully'));
          this.refs.modules.ticket.SET_EDIT_CONTRACT(true);
          this.refs.generateInteractions.policy(
            this.refs.modules.policy.policy,
            this.policy,
            this.valueTab
          );
          await this.refs.modules.policy
            .loadPolicyById(this.$route.params.id)
            .then(() => {
              localStorage.removeItem('tabulacao');
              this.$bus.$emit('cleanValueTab');
            });
          this.dialog = false;
        })
        .catch((err) => {
          this.refs.util.showErrors(err);
          // this.$toast.error('ERROR ? ', err);
          // this.$toast.error(this.$t('toasts.change_contract_detail_error'));
        });
    }
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value) {
      if (this.formPolicy) this.formPolicy.resetValidation();
      if (this.formContract) this.formContract.resetValidation();
      if (this.refs.modules.data.isBilling)
        this.contract = this.refs._.clone(this.refs.modules.contract.contract);
      else this.policy = this.refs._.clone(this.refs.modules.policy.policy);
    }
  }

  private async createCampaignBlock() {
    this.loading = true;

    await this.refs.modules.contract
      .createCampaignBlock(this.refs.modules.contract.contract.Id)
      .catch((err) => {
        this.$toast.error(this.$t('toasts.generic_error'));
        this.loading = false;
        return;
      });

    this.createCampaignBlockStatus = this.refs.modules.contract.blockedInCampaing;

    if (this.refs.modules.ticket.ticket.Id) {
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac2'),
          this.$t('action_desc.ad58')
        )
      );
    }

    this.loading = false;
  }

  private async deleteCampaignBlock() {
    this.loading = true;

    await this.refs.modules.contract
      .deleteCampaignBlock(this.refs.modules.contract.contract.Id)
      .catch((err) => {
        this.$toast.error(this.$t('toasts.generic_error'));
        this.loading = false;
        return;
      });
    this.createCampaignBlockStatus = this.refs.modules.contract.blockedInCampaing;

    if (this.refs.modules.ticket.ticket.Id) {
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac2'),
          this.$t('action_desc.ad59')
        )
      );
    }

    this.loading = false;
  }
}
